function add_to_basket (event_id, ticket_id, qty)
{
	$("#MainForm").attr("action","/tickets_for_event/" + event_id + "/" + ticket_id + "/" + qty);
	$("input[name=_method]").val("PUT");
	$("#MainForm").submit();
}	

function delete_from_basket (event_id, ticket_id)
{
	$("#MainForm").attr("action","/tickets_for_event/" + event_id + "/" + ticket_id);
	$("input[name=_method]").val("DELETE");
	$("#MainForm").submit();
}